import ApplicationSerializer from 'eflex/serializers/application';

export default class HardwareInputDefSerializer extends ApplicationSerializer {
  attrs = {
    task: {
      serialize: false,
      deserialize: false,
    },
    hardwareInputDefConfigs: {
      serialize: false,
      deserialize: false,
    },
  };
}
